import request from '../utils/user_request'
export function loginByUsername (data) {
  // const headers = {
  //   'Authorization': 'Basic YnJvd3Nlcjo='
  // }
  return request({
    url: '/access/login',
    method: 'post',
    // headers,
    data: data
  })
}
export function loginByPasswordToken (data) {
  return request({
    url: '/access/passwordTokenLogin',
    method: 'post',
    data: data
  })
}
export function logout () {
  return request({
    url: '/access/logout',
    method: 'GET'
  })
}

export function getUserInfo () {
  return request({
    url: '/access/getLoginEmployee',
    method: 'get'
  })
}
export function updatePassword (data) {
  return request({
    url: '/access/changePassword',
    method: 'POST',
    data: data
  })
}
export function switchLoginTenant (tenantId) {
  return request({
    url: '/access/switchLoginTenant',
    method: 'GET',
    params: {
      tenantId: tenantId
    }
  })
}
export function switchLoginDepartment (departmentId) {
  return request({
    url: '/access/switchLoginDepartment',
    method: 'GET',
    params: {
      departmentId: departmentId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js